<div class="d-flex d-md-flex justify-space-between align-items-center m-b-10">
  <div class="channel-title m-t-20 d-flex">
    <fui-heading [text]="'Searching for ' + query" [level]="5"></fui-heading>
    <button class="btn btn-secondary btn-sm m-l-10" (click)="clear()">
      <fa-icon icon="times"></fa-icon>
      Clear
    </button>
  </div>
</div>

<div class="community-search-results">
  @if (searching) {
    <div class="m-y-30">
      <fa-icon icon="spinner" animation="spin"></fa-icon>
      Loading posts...
    </div>
  }
  @if (!results) {
    <div class="m-y-40 text-center t-16"></div>
  }
  @if (results && results.length == 0) {
    <div class="m-y-40 t-16">Hmm, we didn't find any posts matching your query. Try something else.</div>
  }
  @if (!searching) {
    @for (hit of results; track hit) {
      <div class="community-post">
        <div class="message-header">
          <img
            [routerLink]="['/profile', hit.author.id]"
            [src]="
              hit.author.id == user.id
                ? user.photoURL
                  ? user.photoURL + (userService.profilePhotoCacheBuster ? '?' + userService.profilePhotoCacheBuster : '')
                  : './assets/images/default_avatar.jpg'
                : hit.author.photo
                  ? hit.author.photo
                  : './assets/images/default_avatar.jpg'
            "
            class="profile-photo pointer"
          />
          <a class="t-18 bold pointer author-name m-l-40" [routerLink]="['/profile', hit.author.id]">{{ hit.author.name }}</a>
          <span class="time-created">{{ hit.created | date: "MMM Do [at] hh:mm" : true }}</span>
          <div class="channels">
            @if (hit.sphere_only && user.is_sphere_admin) {
              <img src="./assets/icons/plus-icon-blue.png" class="circle-icon-btn m-r-15" placement="top" [ngbTooltip]="'Only shows in Studio One Pro+'" />
            }
            @if ((!hit.channels || !hit.channels.length) && (!hit.topics || !hit.topics.length)) {
              <span class="channel" (click)="channelSelected.next('general')">
                {{ "com.skills.general" | translate }}
              </span>
            }
            @for (channel of hit.channels; track channel) {
              @if (communityService.skillsMap[channel] || communityService.extraChannelsMap[channel]) {
                <span class="channel" [class.disabled]="communityService.extraChannelsMap[channel] && !communityService.extraChannelsMap[channel].active" (click)="selectChannel(channel)">
                  #
                  {{
                    communityService.skillsMap[channel]
                      ? ("com.skills." + communityService.skillsMap[channel].string_id | translate)
                      : ("com.skills." + communityService.extraChannelsMap[channel].string_id | translate)
                  }}
                </span>
              }
            }
          </div>
        </div>
        <div class="msg">
          @if (hit._highlightResult?.subject?.value) {
            <div class="main-post-subject" [innerHTML]="hit._highlightResult.subject.value"></div>
          }
          <div class="text main-post-text" [innerHTML]="hit._highlightResult.message.value"></div>
          @if (hit.parentID) {
            <div class="t-14">
              <span class="bold">Replying to:</span>
              <div [innerHTML]="parentsMap[hit.parentID].message"></div>
            </div>
          }
        </div>
        @if (hit.learn_content && hit.learn_content.length && !queued) {
          <div class="post-attachments m-y-20 grid-container wider pad-10">
            @for (item of hit.learn_content; track item) {
              @if (item.content.type == "video") {
                <myp-video-grid-item [video]="item.content"></myp-video-grid-item>
              }
              @if (item.content.type == "course" || item.content.type == "lesson") {
                <myp-learn-list-item [item]="item.content"></myp-learn-list-item>
              }
            }
          </div>
        }
        <div class="search-result-actions">
          <div>
            @if (!betaStringId) {
              <span class="action" [class.green]="hit.markedUseful" (click)="toggleUseful(hit)">
                <fa-icon [icon]="hit.markedUseful ? 'check-circle' : 'circle'"></fa-icon>
                This was useful
              </span>
            }
          </div>
          <div>
            <span class="view-post" (click)="viewPostClicked(hit)">
              View Full Post
              <fa-icon icon="chevron-right"></fa-icon>
            </span>
          </div>
        </div>
        <!-- <div class="text-center m-y-20">
        <span class="btn btn-primary" (click)="viewPostClicked(hit)">View Post <fa-icon icon="chevron-right"></fa-icon></span>
      </div> -->
      </div>
    }
  }

  @if (totalPages > 1) {
    <div class="d-flex justify-content-center m-y-20">
      <div class="d-flex align-items-center">
        <div style="width: 30px">
          @if (page != 1) {
            <fa-icon class="circle-icon-btn" icon="chevron-left" (click)="paginate('previous')"></fa-icon>
          }
        </div>
        <small class="d-block m-x-10">{{ page }} of {{ totalPages }}</small>
        <div style="width: 30px">
          @if (page != totalPages) {
            <fa-icon class="circle-icon-btn" icon="chevron-right" (click)="paginate('next')"></fa-icon>
          }
        </div>
      </div>
    </div>
  }
</div>
